import * as React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import HeadingSection from '../HeadingSection';

jest.mock('@fortawesome/react-fontawesome', () => ({ FontAwesomeIcon: () => null }));

test('keeps its fields mounted while collapsed, so their unsaved edits survive', () => {
  const html = renderToStaticMarkup(
    React.createElement(
      HeadingSection,
      { name: 'Amenities', fieldCount: 1, expanded: false, onToggle: () => {} },
      React.createElement('input', { 'data-cy': 'field' })
    )
  );

  expect(html).toContain('heading-content--collapsed');
  expect(html).toContain('data-cy="field"');
});
